import { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import Data from '../../data/Data';
import { useAuth } from '../../contexts/AuthContext';
import Header from '../Header';
import React from 'react';
import ProjectList from './ProjectList';
import NotificationList from './NotificationList';
import DesignerSettings from './DesignerSettings';
import UserList from './UserList';

function Dashboard() {
    const [site, setSite] = useState('projects');
    const [projects, setProjects] = useState([]);
    const [users, setUsers] = useState([]);
    const [notifications, setNotifications] = useState([]);
    const [user, setUser] = useState();
    const { isLoggedIn } = useAuth();
    const [designerReferences, setDesignerReferences] = useState([]);

    const items = [
        {
            key: 'projects',
            label: 'Projects',
        },
        ...(user && ['customer', 'designer'].includes(Data.getUserType()) ? [{ key: 'notifications', label: 'Notifications' }] : []),
        ...(user && Data.getUserType() === 'designer' ? [{ key: 'designerSettings', label: 'Designer settings' }] : []),
        ...(user && user.admin ? [{ key: 'adminSettings', label: 'Admin Settings' }] : []),
    ];

    const handleTabChange = (key) => {
        setSite(key);

        if (key === 'notifications')
            updateReadNotifications();
    };

    const updateReadNotifications = async () => {
        const updatedNotifications = await Promise.all(
            notifications
                .filter(notification => !notification.read)
                .map(async notification => {
                    await Data.updateReadNotification(notification.id);
                    return { ...notification, unread: notification.readAt === null, readAt: notification.readAt === null ? Date.now() : notification.readAt };
                })
        );
        setNotifications(updatedNotifications);
    }

    async function fetchDashboard() {
        try {
            const fetchedUser = await Data.fetchUser();
            setUser(fetchedUser);
            setProjects(await Data.fetchProjects());

            if (fetchedUser && Data.getUserType() === 'designer') {
                const designer = await Data.fetchDesigner(fetchedUser.id);
                setDesignerReferences(designer.references);
            }
            setNotifications(await Data.fetchNotifications());

            if (fetchedUser && fetchedUser.admin) {
                setUsers(await Data.fetchUsers());
            }
        }
        catch (err) {
            Data.showErrorModal('Failed to fetch: ' + err.message);
        }
    }

    useEffect(() => {
        if (!isLoggedIn)
            window.location = '/login';
        fetchDashboard();
    }, [isLoggedIn]);
    
    useEffect(() => {
        const filteredNotifications = notifications.filter(notification => notification.readAt === null);
        const tabNotification = document.querySelector('#rc-tabs-1-tab-notifications');
    
        if (filteredNotifications.length !== 0 && tabNotification !== null) {
            if (document.querySelector('.notificationDiv') === null) {
                tabNotification.innerHTML += `
                    <div class="notificationDiv">
                        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                            ${filteredNotifications.length > 99 ? '99+' : filteredNotifications.length}
                        </span>
                    </div>`;
            } else {
                document.querySelector('.notificationDiv').innerHTML = `
                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                        ${filteredNotifications.length > 99 ? '99+' : filteredNotifications.length}
                    </span>`;
            }
        } else {
            if (document.querySelector('.notificationDiv') !== null) {
                document.querySelector('.notificationDiv').innerHTML = '';
            }
        }
    }, [notifications]);
    

    return (
        <div className='Dashboard'>
            <Header background authButton sticky />
            <div className='container'>
                <div className='row'>
                    <div className='col-12 work-div'>
                        <Tabs defaultActiveKey="projects" items={items} onChange={handleTabChange} />
                        {site === 'projects' &&
                            <ProjectList
                                projects={projects}
                                setProjects={setProjects}
                                user={user}
                                fetchDashboard={fetchDashboard}
                            />
                        }
                        {site === 'notifications' &&
                            <NotificationList
                                notifications={notifications}
                            />}
                        {site === 'designerSettings' &&
                            <DesignerSettings
                                fetchDashboard={fetchDashboard}
                                designerReferences={designerReferences}
                                user={user}
                            />
                        }
                        {site === 'adminSettings' &&
                            <UserList
                                users={users}
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard;